import React from "react";
import * as d3 from "d3";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import WiremapGenerator from "../../../../../../common/wiremapGenerator";

class VoltageDiagram extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wmContainerWidth: 680,
      wmLineWidth: props.thumbnailView ? 5.5 : 12,
      colors: {
        Standard: {
          1: "#000000", //BLACK
          2: "#000000", //BLACK
          3: "#000000", //BLACK
          4: "#000000", //BLACK
          5: "#000000", //BLACK
          6: "#000000", //BLACK
          7: "#000000", //BLACK
          8: "#000000", //BLACK
          9: "#000000", //BLACK
          short: "#FF0000", //RED
        },
        "568A": {
          1: "#648E28", //GREEN
          2: "#648E28", //GREEN
          3: "#FFA500", //ORANGE
          4: "#4267B2", //BLUE
          5: "#4267B2", //BLUE
          6: "#FFA500", //ORANGE
          7: "#74412F", //BROWN
          8: "#74412F", //BROWN
          9: "#000000", //BLACK
          short: "#FF0000", //RED
        },
        "568B": {
          1: "#FFA500", //ORANGE
          2: "#FFA500", //ORANGE
          3: "#648E28", //GREEN
          4: "#4267B2", //BLUE
          5: "#4267B2", //BLUE
          6: "#648E28", //GREEN
          7: "#74412F", //BROWN
          8: "#74412F", //BROWN
          9: "#000000", //BLACK
          short: "#FF0000", //RED
        },
        TERA: {
          1: "#4267B2", //BLUE
          2: "#4267B2", //BLUE
          3: "#FFA500", //ORANGE
          4: "#74412F", //BROWN
          5: "#74412F", //BROWN
          6: "#FFA500", //ORANGE
          7: "#648E28", //GREEN
          8: "#648E28", //GREEN
          9: "#000000", //BLACK
          short: "#FF0000", //RED
        },
        Coax: {
          4: "#963f0e", //BROWN
          5: "#969696", //GREY
          short: "#FF0000", //RED
        },
        VOICE: {
          "1": "#648E28", //GREEN
          "2": "#FFA500", //ORANGE
          "3": "#4267B2", //BLUE
          "4": "#4267B2", //BLUE
          "5": "#FFA500", //ORANGE
          "6": "#648E28", //GREEN
          short: "#FF0000" //RED
        },
      },
    };
  }
  render() {
    const {
      translate,
      classes,
      wiremapStandard,
      chartMeasurementUnit,
      data,
      results,
      mobileTest,
    } = this.props;

    if (data) {
      chartMeasurementUnit &&
        WiremapGenerator.setChartMeasurementUnit(chartMeasurementUnit);
      translate && WiremapGenerator.setTranslate(translate);

      let { wmContainerWidth, wmLineWidth } = this.state;
      let pinOffset = 0;

      let colors =
        results &&
        results.data &&
        results.data.testedcabletype.toLowerCase() == "coaxialcable"
          ? this.state.colors["Coax"]
          : wiremapStandard
          ? this.state.colors[wiremapStandard]
          : this.state.colors["586B"];
      let wmLineGap = wmLineWidth * 2;
      let wmHeadTailsWidth = wmLineWidth * 2;
      let wmContainerHeight = (wmLineWidth + wmLineGap) * 9 + wmLineGap;

      //Texts
      let texts =
        results &&
        results.data &&
        results.data.testedcabletype.toLowerCase() == "coaxialcable"
          ? ["", "", "", "C", "S"]
          : ["1", "2", "3", "4", "5", "6", "7", "8", "S"];

      if (results && results.data && results.data.testedcabletype == "MobileTest" && results.data.mobileTest.voiceCableModeSelected) {

        colors = this.state.colors["VOICE"];
        pinOffset = 1;
        texts = ["1", "2", "3", "4", "5", "6"];
      }

      let textsData = WiremapGenerator.generateVoltageTexts(
        texts,
        wmContainerWidth,
        wmLineGap,
        wmLineWidth,
        pinOffset
      );

      const voltages = {
        1: mobileTest.pin1Voltage,
        2: mobileTest.pin2Voltage,
        3: mobileTest.pin3Voltage,
        4: mobileTest.pin4Voltage,
        5: mobileTest.pin5Voltage,
        6: mobileTest.pin6Voltage,
        7: mobileTest.pin7Voltage,
        8: mobileTest.pin8Voltage,
      };

      //Head and Tails
      let allHeadTailsData = WiremapGenerator.generateVoltageHeadTail(
        data,
        voltages,
        wmContainerWidth,
        wmHeadTailsWidth,
        wmLineGap,
        wmLineWidth,
        pinOffset
      );

      let lineFunction = d3
        .line()
        .x(function (d) {
          return d.x;
        })
        .y(function (d) {
          return d.y;
        })
        .curve(d3.curveMonotoneX);

      return (
        <div id="wmContainer" ref="wmContainer" className={classes.root}>
          <svg width={wmContainerWidth} height={wmContainerHeight}>
            <defs>
              <marker
                id="ShortMarker"
                markerWidth={wmLineWidth / 3}
                markerHeight={wmLineWidth / 3}
                refX={wmLineWidth / 6}
                refY={wmLineWidth / 6}
              >
                <circle
                  cx={wmLineWidth / 6}
                  cy={wmLineWidth / 6}
                  r={wmLineWidth / 12}
                  style={{ stroke: colors.short, fill: colors.short }}
                />
              </marker>
            </defs>
            {textsData.map((d, i) => {
              return (
                <text
                  key={`wiremapdia-t-${i}`}
                  x={d.x}
                  y={d.y}
                  fontSize={d.fontSize}
                  fontWeight="bold"
                  textAnchor={d.textAnchor}
                >
                  {d.text}
                </text>
              );
            })}
            {allHeadTailsData.headlines.map((d, i) => {
              return (
                <path
                  key={`wiremapdia-l-${i}`}
                  d={lineFunction(d.line)}
                  stroke={colors[d.pin]}
                  strokeWidth={wmLineWidth}
                  fill="none"
                  style={d.dash ? { strokeDasharray: "20, 6" } : {}}
                ></path>
              );
            })}
            {allHeadTailsData.voltagetexts.map((d, i) => {
              return (
                <text
                  key={`wiremapdia-t-${i}`}
                  x={d.x}
                  y={d.y}
                  fontSize={d.fontSize}
                  fontWeight="bold"
                  textAnchor={d.textAnchor}
                >
                  {d.text}
                </text>
              );
            })}
          </svg>
        </div>
      );
    } else {
      return (
        <div id="wmContainer" ref="wmContainer" className={classes.root}></div>
      );
    }
  }

  resizeWiremap() {
    if (this.refs && this.refs.wmContainer) {
      let containerWidth = this.refs.wmContainer.offsetWidth;
      this.setState({
        wmContainerWidth: containerWidth,
      });
    }
  }

  componentDidMount() {
    this.resizeWiremap();
    window.addEventListener("resize", this.resizeWiremap.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeWiremap.bind(this));
  }
}

export default withStyles(styles)(VoltageDiagram);



// WEBPACK FOOTER //
// ./src/components/common/results/views/wiremap/voltagediagram/index.js